import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, FileText, Megaphone, UserPlus } from 'lucide-react';

export default function QuickActions({ 
  onNewModel,
  onPublishPriceList,
  onNewCampaign,
  onNewUser
}) {
  return (
    <div className="flex items-center gap-3">
      <Button 
        onClick={onNewModel}
        className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-lg"
      >
        <Plus className="w-4 h-4 mr-2" />
        Yeni Model
      </Button>
      
      <Button 
        onClick={onPublishPriceList}
        variant="outline"
        className="border-2 border-green-500 text-green-700 hover:bg-green-50"
      >
        <FileText className="w-4 h-4 mr-2" />
        Fiyat Listesi Yayınla
      </Button>
      
      <Button 
        onClick={onNewCampaign}
        variant="outline"
        className="border-2 border-orange-500 text-orange-700 hover:bg-orange-50"
      >
        <Megaphone className="w-4 h-4 mr-2" />
        Kampanya Oluştur
      </Button>
      
      <Button 
        onClick={onNewUser}
        variant="outline"
        className="border-2 border-purple-500 text-purple-700 hover:bg-purple-50"
      >
        <UserPlus className="w-4 h-4 mr-2" />
        Kullanıcı Ekle
      </Button>
    </div>
  );
}
